{
  "daily": "Daily",
  "calendar": "Calendar",
  "library": "Library",
  "nutrition": "Nutrition",
  "athlete": "Athlete",
  "trends": "Trends",
  "labs": "Labs",
  "chat": "Chat",
  "new": "New workout",
  "settings": "Settings",
  "connections": "Connections",
  "more": "More",
  "helpDocs": "Help & docs",
  "athleteSection": "Athlete",
  "manageAthletes": "Manage athletes…",
  "alert": {
    "title_one": "{{count}} source down",
    "title_other": "{{count}} sources down",
    "viewAll": "All connections"
  },
  "aria": {
    "daily": "Go to daily",
    "calendar": "Go to calendar",
    "library": "Open workout library",
    "nutrition": "Open nutrition",
    "athlete": "Open athlete",
    "trends": "Open wellness trends",
    "labs": "Open lab analytics",
    "chat": "Open chat assistant",
    "settings": "Open settings",
    "connections": "Open connections",
    "more": "More destinations",
    "account": "Account menu ({{name}})",
    "accountEmpty": "Account menu (no active athlete)"
  },
  "announce": {
    "library": "Library page",
    "chat": "Chat page",
    "athlete": "Athlete page",
    "athletes": "Athletes page",
    "newWorkout": "New workout",
    "workout": "Workout page",
    "editWorkout": "Edit workout",
    "trends": "Trends page",
    "sleep": "Sleep page",
    "weight": "Weight page",
    "recovery": "Recovery page",
    "activity": "Activity page",
    "settings": "Settings page",
    "connections": "Connections page",
    "nutrition": "Nutrition page",
    "daily": "Daily page",
    "calendar": "Calendar page",
    "zones": "Zones page"
  },
  "chatAssistant": "Chat assistant"
}
